import { Card } from 'antd'
import styled from 'styled-components/macro'
import { FOOD_SAFETY_SURFACE } from 'src/constants/foodSafety'

export const GroupPage = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  padding: 8px 8px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const GroupHero = styled.section`
  margin: 0 0 20px;
  padding: 22px 24px;
  border: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: 12px;
  border-top: 3px solid
    ${({ theme }) => theme.colours?.lettuceGreen || '#b5d922'};
  background: ${FOOD_SAFETY_SURFACE.HERO_BG};
  box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW};
`

export const GroupHeroRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`

export const GroupTitle = styled.h1`
  margin: 0;
  font-size: 1.85rem;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: ${({ theme }) => theme.colours?.bbqBlack || '#132d07'};
`

export const GroupLead = styled.p`
  margin: 8px 0 0;
  max-width: 36rem;
  color: ${({ theme }) => theme.colours?.oliveGrey || '#5c6560'};
  font-size: 15px;
  line-height: 1.45;
`

export const GroupSurface = styled(Card)`
  border-radius: 12px !important;
  border-color: ${FOOD_SAFETY_SURFACE.HERO_BORDER} !important;
  box-shadow: 0 1px 2px rgba(19, 45, 7, 0.04);

  .ant-card-head {
    border-bottom-color: #eef3e4;
    min-height: 48px;
  }

  .ant-card-head-title {
    font-weight: 650;
    letter-spacing: -0.02em;
  }
`

export const GroupTable = styled.div`
  .ant-table-thead > tr > th {
    background: #f7fbec;
    color: #3d4f1f;
    font-weight: 650;
    border-bottom: 1px solid #e4efc8;
  }

  .ant-table-tbody > tr:hover > td {
    background: #fbfdf6 !important;
  }
`
